import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { MessageCircle, X } from "lucide-react";
import { api } from "@/lib/api";

const STORAGE_KEY = "kt_wa_dismissed_at";
const DISMISS_TTL_MS = 1000 * 60 * 60 * 12; // 12 hours

const WhatsAppButton = () => {
  const location = useLocation();
  const [cfg, setCfg] = useState(null);
  const [open, setOpen] = useState(false);
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    // Hide on admin routes.
    if (location.pathname.startsWith("/admin")) return;
    api
      .get("/site/config")
      .then((r) => setCfg(r.data?.whatsapp))
      .catch(() => {});
  }, [location.pathname]);

  useEffect(() => {
    try {
      const t = Number(localStorage.getItem(STORAGE_KEY) || 0);
      if (t && Date.now() - t < DISMISS_TTL_MS) setHidden(true);
    } catch {
      /* ignore */
    }
  }, []);

  if (location.pathname.startsWith("/admin")) return null;
  if (!cfg || !cfg.number) return null;
  if (hidden) return null;

  const link = `https://wa.me/${encodeURIComponent(cfg.number)}?text=${encodeURIComponent(
    cfg.default_message || "Halo CV. Komunika Teknik",
  )}`;

  const dismiss = () => {
    try {
      localStorage.setItem(STORAGE_KEY, String(Date.now()));
    } catch {
      /* ignore */
    }
    setHidden(true);
  };

  return (
    <div
      className="fixed bottom-6 left-6 z-40 flex flex-col items-start gap-3"
      data-testid="whatsapp-floating"
    >
      {open && (
        <div
          className="bg-white border border-[#E4E4E7] shadow-lg p-5 w-[300px] max-w-[calc(100vw-3rem)]"
          data-testid="whatsapp-bubble"
        >
          <div className="flex items-start justify-between gap-3">
            <div>
              <div className="text-xs font-semibold uppercase tracking-[0.18em] text-[#DC2626]">
                Live Sales
              </div>
              <h4 className="font-display text-base font-bold mt-1 leading-snug">
                Konsultasi cepat via WhatsApp
              </h4>
            </div>
            <button
              onClick={dismiss}
              className="p-1 hover:bg-[#F4F4F5] text-[#52525B]"
              aria-label="Tutup"
              data-testid="whatsapp-dismiss"
            >
              <X size={16} />
            </button>
          </div>
          <p className="mt-3 text-sm text-[#52525B] leading-relaxed">
            Tim sales kami online dan siap merespon kebutuhan Anda dalam hitungan
            menit.
          </p>
          <a
            href={link}
            target="_blank"
            rel="noreferrer"
            className="mt-4 inline-flex items-center gap-2 w-full justify-center bg-[#25D366] hover:bg-[#1DA851] text-white px-4 py-3 font-semibold transition-colors"
            data-testid="whatsapp-cta-link"
          >
            <MessageCircle size={16} /> Buka WhatsApp
          </a>
          <div className="mt-3 text-[10px] uppercase tracking-[0.18em] text-[#52525B] font-mono-kt">
            +{cfg.number}
          </div>
        </div>
      )}
      <button
        onClick={() => setOpen((v) => !v)}
        className="relative bg-[#25D366] hover:bg-[#1DA851] text-white w-14 h-14 grid place-items-center shadow-lg transition-colors"
        aria-label="Buka WhatsApp"
        data-testid="whatsapp-toggle-button"
      >
        {open ? <X size={22} /> : <MessageCircle size={24} />}
        {!open && (
          <span className="absolute -top-1 -right-1 w-3 h-3 bg-[#DC2626] animate-pulse" />
        )}
      </button>
    </div>
  );
};

export default WhatsAppButton;
